import { IsNumberString } from "class-validator";

export class GiftCardRedemptionRequestDto {
    cardNumber: string;
    
    amount: number;
  }
  